export const dateWithoutTimezone = dateString => {
  const date = new Date(dateString);
  const tzOffset = date.getTimezoneOffset() * 60000;
  const offsetDate = new Date(date.getTime() + tzOffset);
  return offsetDate;
};

export const dateIsToday = (startDate, todaysDate) =>
  startDate.setHours(0, 0, 0, 0) === todaysDate.setHours(0, 0, 0, 0);

export const todaysDateString = () => {
  const now = new Date();
  let month = now.getMonth() + 1;
  let day = now.getDate();
  const year = now.getFullYear();
  month = month < 10 ? `0${month}` : month;
  day = day < 10 ? `0${day}` : day;
  return `${year}-${month}-${day}`;
};

export const todaysDate = () => dateWithoutTimezone(new Date(todaysDateString()));
